import { publish } from '~/event-bus';
import { HTMLCustomElement } from '~/html-custom-element';

customElements.define(
  'product-listing',
  class ProductListing extends HTMLCustomElement {
    connectedCallback() {
      if (super.connectedCallback) super.connectedCallback();

      this.setEventListeners();
    }

    /**
     * Applies event listeners.
     */
    setEventListeners() {
      this.on('submit', this.targets['filter-form'], this.handleFilterFormSubmit.bind(this));
    }

    /**
     * Handles the filter form submit event.
     * @param {SubmitEvent} event - The event payload.
     */
    handleFilterFormSubmit(event) {
      const params = new URLSearchParams(event.detail);
      const query = [];

      params.forEach((value, key) => {
        /**
         * Filter out empty or default values.
         */
        if (value === '' || (key === 'sort_by' && value === this.targets['filter-form'].dataset.defaultSortBy)) {
          return;
        }

        query.push(`${key}=${value}`);
      });

      this.setSection(query.join('&'));
    }

    /**
     * Fetches and returns the section content.
     * @param {String} query - Optional query parameters.
     * @returns {Promise}
     */
    fetchSection(query) {
      return fetch(`${window.location.pathname}?section_id=${this.dataset.sectionId}${query ? `&${query}` : ''}`).then(
        (response) => response.text()
      );
    }

    /**
     * Sets the section.
     * - Fetches the section content, and injects it.
     * @param {String} query - Optional query parameters.
     */
    async setSection(query) {
      const section = await this.fetchSection(query);

      publish('product-listing-update', {
        sections: {
          [this.dataset.sectionId]: section,
        },
      });

      this.setQueryParams(query);
    }

    /**
     * Sets the collection query parameters.
     * @param {String} query - Optional query parameters.
     */
    setQueryParams(query) {
      window.history.pushState(null, null, query === '' ? window.location.pathname : `?${query}`);
    }
  }
);
